<template>
  <GamConfirmModal
    :title="localize(locationAskSentenceKey(reason))"
    :keep-label="localize('location.ask.allow')"
    :destructive-label="localize('location.ask.not_now')"
    neutral-confirm
    wide
    @close="emit('dismiss')"
    @keep="emit('allow')"
    @confirm="emit('dismiss')"
  />
</template>

<script lang="ts" setup>
import { localize } from '@/core/gambits';
import GamConfirmModal from '@/views/components/GamConfirmModal.vue';
import type { LocationAskReason } from '@/views/composables/hooks/useLocationAsk';
import { locationAskSentenceKey } from '@/views/composables/hooks/useLocationHelp';

defineProps<{ reason: LocationAskReason }>();

const emit = defineEmits<{ allow: []; dismiss: [] }>();
</script>
